import { Component, computed, inject, input } from "@angular/core";
import { NIASBizBllModelsAuthDocumentInfo } from "../../api/v1";
import { AuthService } from "../../services/auth.service";
import { TranslatePipe } from "@ngx-translate/core";
import { JIPSService } from "../../services/jips.service";
import { NzFlexModule } from "ng-zorro-antd/flex";

@Component({
    selector: 'app-authorization-info-content',
    templateUrl: './authorization-info-content.component.html',
    imports: [
        TranslatePipe,
        NzFlexModule
    ]
})
export class AuthorizationInfoContentComponent {
    private authService: AuthService = inject(AuthService);
    private jipsService: JIPSService = inject(JIPSService);

    public authInfoPage = input<'authorization-managment' | 'authorization-eServices'>('authorization-managment');
    public authDocumentInfo = input<NIASBizBllModelsAuthDocumentInfo | null>(null); 

    public forEntityLabel = computed<string>(() => {
        if(this.authInfoPage() == 'authorization-managment') {
            return 'EAUTHORIZATION-MANAGMENT.AUTHORIZATION-INFO-CONTENT.FOR-ENTITY-LABEL';
        }else {
            return 'EAUTHORIZATION-ESERVICES.AUTHORIZATION-INFO-CONTENT.FOR-ENTITY-LABEL';
        }
    });

    public forEntityName = computed<string>(() => {
        if(this.authService.userValue?.ActAsModel?.ForLegalIps) {
            return this.authService.userValue?.ActAsModel?.ForLegalName || '';
        }else {
            return `${this.authService.userValue?.ActAsModel?.ForPersonFirstName} ${this.authService.userValue?.ActAsModel?.ForPersonLastName}`
        }
    });

    public forEntityKey = computed<string>(() => {
        if(this.authService.userValue?.ActAsModel?.ForLegalIps) {
            const getJipsKey = this.jipsService.getJipsData(this.authService.userValue.ActAsModel.ForLegalIzvor_reg || 0);
            const getJipsValue = this.authService.userValue?.ActAsModel?.ForLegalIps;
            return `${getJipsKey}: ${getJipsValue}`;
        }else {
            return 'OIB: ' + this.authService.userValue?.ActAsModel?.ForPersonOib
        }
    });

    public fromEntityLabel = computed<string>(() => {
        if(this.authInfoPage() == 'authorization-managment') {
            return 'EAUTHORIZATION-MANAGMENT.AUTHORIZATION-INFO-CONTENT.FROM-ENTITY-LABEL';
        }else {
            return 'EAUTHORIZATION-ESERVICES.AUTHORIZATION-INFO-CONTENT.FROM-ENTITY-LABEL';
        }
    })
    public fromEntityName = computed<string>(() => this.authService.userValue?.UserDataExtended?.LoggedPersonFullName || '');
    public fromEntityKey = computed<string>(() => `OIB: ${this.authService.userValue?.UserDataExtended?.LoggedPersonOib}`);

}
